// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"HZ-z","sponsoredTooltipWrapper":"IZ-z","sponsoredTooltip":"JZ-z","newCard":"KZ-z"};